import { createTheme } from "@mui/material/styles";
//get the Khand font from Google Fonts
//https://fonts.google.com/specimen/Khand
//Click on the "+" icon to add the font to your collection
//Click on the "Family Selected" bar at the bottom of the screen
//Copy the <link> tag and paste it into the <head> of your index.html file
//Add the font to the typography section of your theme

const theme = createTheme({
	typography: {
		fontFamily: "Khand",
	},
	palette: {
		primary: {
			main: "#1976d2",
			contrastText: "#000000",
			textWhite: "#FFFFFF",
			grayscale: "rgba(0, 0, 0, 0.3)",
		},

		mapIcon: {
			//make from green to red as the snow depth increases
			zeroToThree: "#77cc00",
			threeToSix: "#ccc900",
			sixToNine: "#cc8b00",
			nineToTwelve: "#cc4b00",
			twelvePlus: "#cc0000",
		},

		// Color for pagination component

		background: {
			default: "#424242", // Dark grey background color
		},
		text: {
			primary: "#FFFFFF", // White text color
			secondary: "#000000", // Light grey text color
			black: "#000000", // Black text color
		},
		action: {
			active: "#FF5722", // Active state color for buttons and links
			hover: "#FF5722", // Hover state color for buttons and links
			selected: "#FF5722", // Selected state color for buttons and links
		},
		button: {
			text: "#FFFFFF", // Text color for buttons
			background: "#FF5722", // Background color for buttons
		},
		highlight: {
			main: "#FF5722", // Color for highlighting elements
		},
		error: {
			main: "#c2000a", // Color for error messages
		},
		warning: {
			main: "#ffe785", // Color for warning messages
		},
		success: {
			main: "#2aa324", // Color for success messages
		},
		info: {
			main: "#9c9c9c", // Color for informational messages
		},
		divider: "#CCCCCC", // Color for dividers
		disabled: {
			main: "#CCCCCC", // Color for disabled elements
		},
		secondary: {
			main: "#64a6e8",
			grayscale: "rgba(0, 0, 0, 0.3)",
			text: "#000000",
		},
	},
	components: {
		MuiTextField: {
			styleOverrides: {
				root: {
					text: {
						primary: "#FFFFFF",
					},
				},
			},
		},
	},

	// Add more customizations to the theme here
});

export default theme;
